import { AbstractControl, FormGroup, ValidationErrors } from '@angular/forms';

export const EMAIL_PATTERN =
  // eslint-disable-next-line no-useless-escape
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export class CustomFormValidators {
  static emailValidator(control: AbstractControl): ValidationErrors | null {
    const email = control.value as string;

    return email && (!email.length || email.match(EMAIL_PATTERN))
      ? null
      : { boelsInvalidEmail: true };
  }

  static emailsMustMatch(email: string, emailConfirmation: string): any {
    const validator = (formGroup: FormGroup) =>
      controlsMustMatch(
        formGroup,
        email,
        emailConfirmation,
        'boelsEmailsMustMatch',
      );

    return validator;
  }

  static onlyAlphaNumerics(control: AbstractControl): ValidationErrors | null {
    const regEx = new RegExp(/^[A-Za-z0-9]+$/);
    const str = String(control.value);
    if (str === '') {
      return null;
    }
    return regEx.test(str) ? null : { boelsContainsSpecialCharacters: true };
  }
}

export function controlsMustMatch(
  formGroup: FormGroup,
  firstControlName: string,
  secondControlName: string,
  errorName: string,
): void {
  const firstControl = formGroup.controls[firstControlName];
  const secondControl = formGroup.controls[secondControlName];

  if (secondControl.errors && !secondControl.errors[errorName]) {
    return;
  }

  secondControl.setErrors(
    firstControl.value !== secondControl.value ? { [errorName]: true } : null,
  );
}
